module.exports = __webpack_public_path__ + "img/politicas.d9561288.gif";